import { style, animate, transition, state, trigger, AnimationTriggerMetadata } from '@angular/animations'

export const slideInOutAnimation = trigger('slideInOut', [
  state('true', style({ width: '*' })),
  state('false', style({ width: '0' })),
  transition('true => false', animate('300ms ease-in')),
  transition('false => true', animate('300ms ease-out')),
])

// Example: <div [@fadeIn]="{ params: { duration: 1000 } }">
export const fadeInAnimation = trigger('fadeIn', [
  state('in', style({ opacity: 1 })),
  transition(':enter', [style({ opacity: 0 }), animate('{{ duration }}ms')], {
    params: { duration: 200 },
  }),
])

export const fadeUpAnimation: AnimationTriggerMetadata = trigger('fadeUp', [
  state('in', style({ opacity: 1, transform: 'translate(0px, 10px)' })),
  transition(
    ':enter',
    [style({ opacity: 0, transform: 'translate(0px, 0px)' }), animate('{{ duration }}ms ease-out')],
    {
      params: { duration: 200 },
    },
  ),
])
